// extracted by mini-css-extract-plugin
export default {"container":"MainNavigation_container__ryKZQ","title":"MainNavigation_title__+kVm8","nav":"MainNavigation_nav__dUXys","active":"MainNavigation_active__uO4gk"};